import React from 'react';
import { Phone, Star, ChevronRight } from 'lucide-react';
import { HERO_BULLETS, CONTACT, IMAGES } from '../mock';
import { Button } from './ui/button';

export default function Hero({ onBook }) {
  return (
    <section id="top" className="relative pt-24 md:pt-32 pb-14 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-70" />
      <div className="absolute -top-32 -left-40 w-[520px] h-[520px] rounded-full blur-3xl" style={{background:'radial-gradient(circle,#a855f7 0%,transparent 60%)',opacity:.20}} />
      <div className="absolute -bottom-24 -right-32 w-[520px] h-[520px] rounded-full blur-3xl" style={{background:'radial-gradient(circle,#ec4899 0%,transparent 60%)',opacity:.18}} />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden glow-ring">
            <img src={IMAGES.hero} alt="One Stop Carz workshop" className="w-full h-[360px] md:h-[440px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-transparent to-transparent" />
            <div className="absolute left-4 bottom-4 right-4 flex items-end justify-between">
              <div className="bg-black/55 backdrop-blur rounded-xl px-3 py-2 border border-purple-900/60">
                <div className="text-white text-lg font-bold">₹4,999 <span className="text-xs text-gray-400 font-medium">/ Diamond AMC</span></div>
                <div className="text-[11px] text-gray-300">48 સર્વિસ • 2 વર્ષ • ફક્ત ₹111/સર્વિસ</div>
              </div>
              <div className="flex items-center gap-1 bg-black/55 rounded-full px-3 py-1 border border-purple-900/60">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />)}
              </div>
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="flex flex-wrap gap-2 mb-5">
            <span className="tag-pill"><Star className="w-3 h-3 fill-white" /> વડોદરાનું ભરોસાપાત્ર વર્કશોપ</span>
            <span className="tag-pill">🚗 ફ્રી પિકઅપ & ડ્રોપ</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
            <span className="text-white">ONE STOP </span>
            <span className="gradient-text">CARZ</span>
          </h1>
          <p className="mt-4 text-gray-300 text-base md:text-lg max-w-xl">
            તમારી કારની સંપૂર્ણ કેર — એક જ જગ્યાએ. AMC અને સર્વિસ પેકેજો જે પૈસા બચાવે અને કાર નવી જેવી રાખે.
          </p>

          <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {HERO_BULLETS.map((b, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-gray-200">
                <span className="mt-1 inline-block w-2 h-2 rounded-full" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}} />
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Button onClick={onBook} className="gradient-btn rounded-full h-12 px-6 font-semibold">
              અત્યારે જ બુક કરો <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
            <a href={`tel:+91${CONTACT.phone}`} className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full border border-purple-800/60 text-gray-200 hover:border-pink-500/70">
              <Phone className="w-4 h-4 text-pink-400" /> કૉલ કરો
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
